// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"56":"politica","223":"channels","486":"bcompliance","915":"empresas"}[chunkId] + "." + {"56":"c8da409f","223":"e733fa24","486":"f63c2a9d","915":"85ee9d02"}[chunkId] + ".css";
};